







import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import {
  UserDefinitionWindowKinds,
} from "../../../../domain/document";
import {
  IUserDefinitionItem,
} from "../../../../domain/document/items";
import {
  Patient,
} from "../../../../domain/patient";
import LightUserDefinitionDialog from "./LightUserDefinitionDialog.vue";
import InstitutionSelectDialog from "./InstitutionSelectDialog.vue";
import { UserDefinitionSelectResult } from "./UserDefinitionSelectResult";
import { KeyValuePair } from "../../../../domain/system";

@Component({
  components: {
    LightUserDefinitionDialog,
    InstitutionSelectDialog,
  },
})
export default class UserDefinitionSelectDialog extends Mixins() {
  @Prop()
  patient: Patient;
  
  async show(source: IUserDefinitionItem, initialFilterParameters: KeyValuePair<string, string>[] = []): Promise<UserDefinitionSelectResult> {
    try {
      return (source.userDefinitionWindowKind === UserDefinitionWindowKinds.Institution)
        ? this.showInstitutionSelectDialog(source)
        : this.showUserDefinitionDialog(source, initialFilterParameters);
    } catch (e) {
      this.$error(
        "ユーザ定義情報取得失敗",
        "ユーザ定義情報を取得できませんでした。",
        e,
      );
      return null;
    }
  }

  async showInstitutionSelectDialog(source: IUserDefinitionItem): Promise<UserDefinitionSelectResult> {
    const isProven = this.isProvenUserDefinition(source.userDefinitionKey);
    const isAvailable = isProven || await this.isAvailableUserDefinition(source.userDefinitionKey);
    if (!isAvailable) {
      // ユーザ定義のCSVが見つからない場合は何もしない（V1と挙動をあわせる）
      this.$logger.warn("ユーザ定義のCSVが見つからないため、施設選択ダイアログを表示できません。");
      return null;
    }
    if (!isProven) {
      this.addProvenUserDefinition(source.userDefinitionKey);
    }
    const dialog = this.$refs.institutionSelectDialog as InstitutionSelectDialog;
    return dialog.show(source.userDefinitionKey, this.patient.id);
  }

  async showUserDefinitionDialog(source: IUserDefinitionItem, initialFilterParameters: KeyValuePair<string, string>[]): Promise<UserDefinitionSelectResult> {
    const isProven = this.isProvenUserDefinition(source.userDefinitionKey);
    const isAvailable = isProven || await this.isAvailableUserDefinition(source.userDefinitionKey);
    if (!isAvailable) {
      const result = new UserDefinitionSelectResult();
      result.items = [];
      result.isBlank = true;
      return result;
    }
    if (!isProven) {
      this.addProvenUserDefinition(source.userDefinitionKey);
    }
    const dialog = this.$refs.selector as LightUserDefinitionDialog;
    return dialog.show(source.userDefinitionKey, source.userDefinitionSelectionMode, initialFilterParameters);
  }

  private isProvenUserDefinition(key: string): boolean {
    if (!this._availableUserDefinitionKeys) { return false; }
    return (this._availableUserDefinitionKeys.indexOf(key) >= 0);
  }
  
  private _availableUserDefinitionKeys: string[];

  private addProvenUserDefinition(key: string): void {
    if (this.isProvenUserDefinition(key)) { return; }
    if (!this._availableUserDefinitionKeys) {
      this._availableUserDefinitionKeys = [];
    }
    this._availableUserDefinitionKeys.push(key);
  }

  private async isAvailableUserDefinition(key: string): Promise<boolean> {
    try {
      const repository = DomainRegistry.format.getFormatRepository();
      return await repository.isAvailableUserDefinition(key);
    } catch (e) {
      // APIがまだ未実装のときなど
      console.warn(e);
      return true;
    }
  }
}
